<template>
  <div class="share-container">
    <a href="" class="share" v-on:click.prevent="visible=!visible">Share</a>
    <ul class="share-list" :class="{visible: visible}">
      <li class="title">Share to</li>
      <li><a class="btn-like ifb" :href="sharerLink('facebook')" v-on:click.prevent="openShare('facebook')">Facebook</a></li>
<!--       <li><a class="btn-like iig" :href="sharerLink('instagram')" v-on:click.prevent="openShare('instagram')">Instagram</a></li> -->
      <li><a class="btn-like itw" :href="sharerLink('twitter')" v-on:click.prevent="openShare('twitter')">Twitter</a></li>
<!--       <li><a class="btn-like ipi" :href="sharerLink('pinterest')" v-on:click.prevent="openShare('pinterest')">Pinterest</a></li> -->
      <li><a class="btn-like iin" :href="sharerLink('linkedin')" v-on:click.prevent="openShare('linkedin')">Linkedin</a></li>
      <li><a class="btn-like iem" :href="sharerLink('email')" v-on:click.prevent="openEmail('email')">Email</a></li>
      <li class="copy"><a class="btn-main" :href="href()" v-on:click.prevent="doCopy">Copy to clipboard</a></li>
    </ul>
  </div>
</template>

<script>
export default {
  data: ()=>({
    visible: false,
  }),
  methods: {
    sharerLink(target) {
      var lnk=encodeURIComponent(location.href);
      var tit=encodeURIComponent(document.title);
      if (target=="facebook")
        return "https://www.facebook.com/sharer/sharer.php?u="+lnk;
      if (target=="twitter")
        return "https://twitter.com/intent/tweet?text="+tit+"&url="+lnk;
      if (target=="pinterest")
        return "https://www.pinterest.com/pin/create/button/?description="+tit+"&url="+lnk;
      if (target=="linkedin")
        return "https://www.linkedin.com/sharing/share-offsite/?url="+lnk;
      if (target=="email")
        return "mailto:?Subject="+tit+"&body="+tit+"%0A"+lnk;
      return '';
    },
    openShare(target) {
      this.visible=false;
      var link=this.sharerLink(target);
      if (link)
        window.open(link, "share-window", "innerWidth=450,innerHeight=300");
    },
    openEmail(target) {
      this.visible=false;
      var link=this.sharerLink(target);
      if (link)
        window.open(link, "_blank");
    },
    href() {
      return location.href;
    },
    doCopy: function() {
      this.visible=false;
      var textArea=document.createElement("textarea");
      textArea.style.position="fixed";
      textArea.style.left="-1000px";
      
      textArea.value=location.href;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      var successful=false;
      try {
        successful=document.execCommand('copy');
      } catch (err) {
      }
      document.body.removeChild(textArea);
    },
    
  },
}
</script>
